// extracted by mini-css-extract-plugin
export var active = "_7q-d";
export var blink = "_7q-e";
export var container = "_7q-5";
export var controls = "_7q-0";
export var controlsRight = "_7q-1";
export var fakeCursor = "_7q-c";
export var hidden = "_7q-b";
export var quillContainerSmall = "_7q-7";
export var quillEditor = "_7q-6";
export var quillEditorSmall = "_7q-8";
export var quillFormatButtons = "_7q-a";
export var quillToolbar = "_7q-9";
export var removePadding = "_7q-2";
export var state = "_7q-3";
export var stateTitle = "_7q-4";